import {
  GoogleSitesLink,
  createExternalLink,
  Molenda2007Link,
  Morrison2013Link,
} from '../../common/links'
const CommonMistakesLink = createExternalLink(
  'https://drive.google.com/file/d/12AddaHRJFvTFPGmgn8eaAPZ2szF_DWcX/view?usp=sharing',
  'common mistakes in web page design'
)
const PowerPointPrototypeLink = createExternalLink(
  'https://dawnleberknight.now.sh/projects/instructional-design-and-assessment-report',
  'PowerPoint Prototype of Instructional Unit'
)

const data = {
  titleMain: 'WWW 722 ID Project',
  courseNumber: 'EDET 703',
  projectLink: 'https://sites.google.com/view/leberknight-idproject',
  standardName: 'AECT 2 – Content Pedagogy',
  standardSummary:
    'Candidates develop as reflective practitioners able to demonstrate effective implementation of educational technologies and processes based on contemporary content and pedagogy.',
  contextAndConditions:
    'During the Spring 2020 Design and Development Tools II (EDET 703) course with Dr. Gary Senn, we further developed our technical skills using current and emerging technologies to create a web-based project that included instructional and multimedia elements.',
  scope: `The goal of this assignment was to create a web-based version of the previously developed ${PowerPointPrototypeLink} from EDET 722. After researching the biggest mistakes in webpage design, I focused on best practices for web delivery and created a series of webpages to present the EDET 722 instructional unit online.`,
  role:
    'I completed this project by myself and served as the instructional designer and developer.',
  instructionalDesign: `Since this project was based on the instructional design work completed in EDET 722, I completed only a couple of the core elements from the ADDIE (${Molenda2007Link}) and MRK (${Morrison2013Link}) instructional design models, which included designing instructional strategies and the message and developing instructional delivery and evaluation instruments which were appropriate for web-based education.`,
  performanceIndicator: [
    {
      title: 'Creating',
      indicator:
        'Candidates apply content pedagogy to create appropriate applications of processes and technologies to improve learning and performance outcomes.',
      implementation:
        'Expanding on previously created instructional content, I followed best practices for web delivery when creating the series of webpages.',
    },
    {
      title: 'Using',
      indicator:
        'Candidates implement appropriate educational technologies and processes based on appropriate content pedagogy.',
      implementation: `I used ${GoogleSitesLink} and many of the platform’s features, such as collapsible text to format true/false questions.`,
    },
    {
      title: 'Assessing/Evaluating',
      indicator:
        'Candidates demonstrate an inquiry process that assesses the adequacy of learning and evaluates the instruction and implementation of educational technologies and processes grounded in reflective practice.',
      implementation:
        'In order to assess learning, I used multiple choice and true/false questions which were aligned with learning objectives.',
    },
    {
      title: 'Managing',
      indicator:
        'Candidates manage appropriate technological processes and resources to provide supportive learning communities, create flexible and diverse learning environments, and develop and demonstrate appropriate content pedagogy.',
      implementation:
        'Similar to the PowerPoint version of the instructional unit, I created an interactive, web-based module which is self-paced in order to provide flexibility for the learner. Making the same content available in both formats (PowerPoint and web-based) provides options for delivery of instruction to help support the diverse needs of learners.',
    },
    {
      title: 'Ethics',
      indicator:
        'Candidates design and select media, technology, and processes that emphasize the diversity of our society as a multicultural community.',
      implementation:
        'In order to accommodate a diverse group of learners, the series of webpages are designed with user-friendly navigation and simple layout with limited text, subheadings and bulleted lists.',
    },
  ],
  reflection: `Since I was already familiar with Google Sites platform from previous courses, this artifact demonstrates more advanced application of knowledge and skills. I was able to focus fully on creating the web delivery, since the content was already developed previously in the EDET 722 course. For this project, I continually referred back to ${CommonMistakesLink} (another assignment in the course) in order to make sure that I was following best practices when creating the series of webpages, which included eliminating some non-essential text and images for a more clean and simple design.`,
}

export default data
